import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowSymbolLeft = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 12L3 12L3.5 12", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M9 19C9 15 6 13 3 12.5L3 11.5C6 11 9 9 9 5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowSymbolLeft.js.map